/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsStagingService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './HubSpotFormsStagingService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsStagingService#promoteStagedForm
 */
export const PROMOTE_STAGED_FORM_MUTATION_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsStagingService_promoteStagedForm';
export const PROMOTE_STAGED_FORM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PROMOTE_STAGED_FORM_MUTATION_FIELD_NAME,
  args: ['stagedFormId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.promoteStagedFormRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsStagingService#getStagedForm
 */
export const GET_STAGED_FORM_QUERY_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsStagingService_getStagedForm';
export const GET_STAGED_FORM_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STAGED_FORM_QUERY_FIELD_NAME,
  args: ['stagedFormId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getStagedFormRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsStagingService#deleteStagedForm
 */
export const DELETE_STAGED_FORM_MUTATION_FIELD_NAME = 'com_hubspot_forms_rpc_HubSpotFormsStagingService_deleteStagedForm';
export const DELETE_STAGED_FORM_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_STAGED_FORM_MUTATION_FIELD_NAME,
  args: ['stagedFormId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.deleteStagedFormRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});